import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Box, Typography, Switch, Chip, Tooltip, CircularProgress } from "@mui/material";
import HotelCard from "./HotelCard";

const HotelsList = ({ hotels, viewMode = "grid", permissions, onView, onEdit, onDelete, onToggleActive, toggleLoading }) => {
  if (viewMode === "list") {
    return (
      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid rgba(226, 232, 240, 0.8)' }}>
        <Table size="small">
          <TableHead sx={{ bgcolor: '#f8fafc' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 700 }}>Hotel Name</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Location</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Type</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Rating</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 700 }} align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {hotels.map((hotel) => {
              const isActive = hotel.isActive !== false;
              const isLoading = Boolean(toggleLoading && toggleLoading[hotel._id]);

              return (
                <TableRow key={hotel._id} hover sx={{ bgcolor: isActive ? 'inherit' : '#fafafa' }}>
                  <TableCell>
                    <Typography variant="body2" fontWeight={600} color={isActive ? "primary" : "text.secondary"}>
                      {hotel.hotel_name}
                    </Typography>
                  </TableCell>
                  <TableCell>{hotel.destination} - {hotel.sub_destination}</TableCell>
                  <TableCell>{hotel.type}</TableCell>
                  <TableCell>⭐ {hotel.rating || 0}</TableCell>
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                      {isLoading ? (
                        <CircularProgress size={18} />
                      ) : (
                        <Tooltip title={isActive ? "Deactivate hotel" : "Activate hotel"}>
                          <Switch
                            size="small"
                            checked={isActive}
                            onChange={(e) => onToggleActive && onToggleActive(hotel, e)}
                            color="success"
                            disabled={isLoading || (permissions && !permissions.edit)}
                          />
                        </Tooltip>
                      )}
                      <Chip
                        size="small"
                        label={isActive ? "Active" : "Inactive"}
                        color={isActive ? "success" : "default"}
                        variant={isActive ? "filled" : "outlined"}
                        sx={{ fontWeight: 600, fontSize: "0.72rem" }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell align="right">
                    <Box display="flex" justifyContent="flex-end" gap={1}>
                      <Button size="small" variant="outlined" onClick={() => onView(hotel)}>View</Button>
                      {permissions?.edit && (
                        <Button size="small" variant="outlined" color="success" onClick={() => onEdit(hotel)}>Edit</Button>
                      )}
                      {permissions?.delete && (
                        <Button size="small" variant="outlined" color="error" onClick={() => onDelete(hotel._id)}>Delete</Button>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              );
            })}
            {hotels.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 3, color: 'text.secondary' }}>
                  No hotels found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  return (
    <Grid container spacing={3}>
      {hotels.map((hotel) => (
        <Grid item xs={12} sm={6} md={3} key={hotel._id}>
          <HotelCard
            hotel={hotel}
            onView={onView}
            onEdit={onEdit}
            onDelete={onDelete}
            onToggleActive={onToggleActive}
            toggleLoading={toggleLoading}
            permissions={permissions}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default HotelsList;
